const VERSION = "v1";
const ADMIN = "/admin";
// exports.ALLOWED_IDLE_TIME = 1800000;
exports.CONFIG = {
  BASE_URL: "https://api.selectiva.org/" + VERSION + ADMIN,
  PUBLIC_BASE_URL: "https://api.selectiva.org/v2/public",
};

exports.ENTITIES = {
  CAUSE: "causes",
  CAUSE_CATEGORY: "category",
  CAUSE_TAG: "tags",
  TRANSACTION: "transactions",
  TRANSACTIONLINEITEMS: "transactionLineItems",
  ORGANIZATION: "organizations",
  DONOR: "donors",
  AUTH: "auth",
  FEATURED: "featured",
  FORGOT_PASSWORD: "forgot",
  OTP: "otp",
  RESET_PASSWORD: "reset",
  PREFILLED: "preField",
  ROLE: "role",
  USER: "users",
  CLUB: "club",
  CASUE_MEDIA: "causemedia",
  USER_PERMISSION: "permission",
  USD: "usd",
  ADMINS: "admins",
  FINANCE: "finance",
  CHANGE_PASSWORD: "changePassword",
  ORGANIZATION_CLUB: "organizationClub",
  DASHBOARD: "dashBoard",
  TOP_CAUSES: "topCause",
  LINE_GRAPH: "lineGraph",
  BATCH: "batch",
  UPLOAD_EXCEL: "upload",
  EXECUTE_BATCH: "executeBatch",
  STATUS: "statusChange",
  EMAIL: "email",
  IDLIST: "idList",
  TEMPLATE: "template",
  ARCHIVE_TEMPLATE: "archiveTemplate",
  TEMPLATE_CATEGORY: "category",
  TEMPLATE_VARIABLES: "variable",
  CAMPAIGN: "campaign",
  CAMPAIGN_TEMPLATES: "campaignTemplates",
  RECIPTIENT: "reciptient",
  CLONE: "clone",
  GIVING: "giving",
  TEST_EMAIL: "test",
  VERIFY_FROM_EMAIL: "verify",
  COUNTRY: "country",
  STATE: "state",
  CITY: "city",
  ARTICLES: "articles",
  PREVIEW: "preview",
  VERSION: "version",
  VERSIONS: "versions",
  SPONSOR: "sponsors",
  WALLET: "wallet",
  WALLET_TRANSACTION: "walletTransaction",
  WALLET_FORM: "walletForm",
  SPONSORED_AMOUNT: "sponsoredAmount",
  ROLE_USER: "userRoles",
  LOGO: "sponsors",
  DONOR_REPORT: "donorReport",
  DONOR_DETAILS: "donorDetails",
};

exports.STATUS = {
  FAIL: "fail",
  SUCCESS: "success",
};
exports.TRANSACTION_LIMIT = 6;

exports.GATRACKINGID = "UA-153570275-2";

exports.DEBUG = false;

exports.PASSWORDLENGTH = 10;

exports.USERSTATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  ALL: "ALL",
};
exports.ENUMS = {
  DRAFT: "DRAFT",
  UNDER_REVIEW: "UNDER_REVIEW",
  PUBLISH: "PUBLISHED",
  REJECT: "REJECTED",
  APPROVE: "APPROVED",
  DELETE: "DELETE",
  INACTIVE: "Inactive",
  ARCHIVED: "ARCHIVED",
  UNPUBLISH: "UNPUBLISHED",
  FEATURE: "FEATURE",
  SCHEDULED: "SCHEDULED",
  SEND: "SEND",
  SENT: "SENT",
  IN_PROGRESS: "IN-PROGRESS",
  ALREADY: "ALREADY",
};
exports.CAUSE_ENUM = {
  REJECT: "REJECT",
  APPROVE: "APPROVE",
  PUBLISH: "PUBLISH",
  NEW_VERSION: "Create New Version",
  ALL_VERSION: "All Version",
};
exports.CONTEXTS = {
  SELORG: "sel-org",
  SELORG_ID: "1",
  USD: "usd",
  USD_ID: "2",
  ORG: "organization",
  CLUB: "club",
};

exports.ABBREVIATION = {
  NPO: "Non Profit",
  SCHOOL: "School",
  PTA: "Parents Teacher Association",
};

exports.ORGSTATUS = {
  ACTIVE: "ACTIVE",
  DEACTIVE: "DEACTIVE",
  INACTIVE: "INACTIVE",
};

exports.CLASSCOLOR = [
  "dataLetters bg-red",
  "dataLetters bg-pink",
  "dataLetters bg-purple",
  "dataLetters bg-deepPurple",
  "dataLetters bg-indigo",
  "dataLetters bg-blue",
  "dataLetters bg-cyan",
  "dataLetters bg-teal",
  "dataLetters bg-green",
  "dataLetters bg-lime",
  "dataLetters bg-amber",
  "dataLetters bg-orange",
  "dataLetters bg-deepOrange",
  "dataLetters bg-blueGray",
  "dataLetters bg-gray",
  "dataLetters bg-darkGray",
  "dataLetters bg-indigoDarken",
  "dataLetters bg-tealDarken",
  "dataLetters bg-limeDarken",
  "dataLetters bg-tealAccent",
  "dataLetters bg-redLighten",
  "dataLetters bg-brownDarken",
  "dataLetters bg-maroon",
  "dataLetters bg-magenta",
];

exports.ERROR_COMPONENTS = {
  ERROR_404: "Error404Page",
};
exports.ADMIN_TYPE = {
  CLIENT: "CLIENT",
  SELECTIVA: "SELECTIVA",
};
exports.SYSTEM_LEVEL_ACCESS = {
  SINGLE: "SINGLE",
  MULTI: "MULTI",
};

exports.TABLE_OPTIONS = [
  {
    text: "10",
    value: 10,
  },
  {
    text: "20",
    value: 20,
  },
  {
    text: "30",
    value: 30,
  },
  {
    text: "40",
    value: 40,
  },
  {
    text: "50",
    value: 50,
  },
];

exports.CONTEXT_ROUTE_MAPPING = {
  admin: "Admin",
  organization: "Organization",
  usd: "USD",
  club: "Club",
};
exports.API_STATUS = {
  SUCCESS: "success",
  FAIL: "fail",
};

exports.FINANCE_VALUE = {
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

exports.TOAST_STATUS = {
  CREATE: "Create",
  UPDATE: "Update",
  DELETE: "Delete",
  ARCHIVED: "ARCHIVED",
  ERROR: "Error",
  ADDED: "ALREADY_ADDED",
  CLONE: "CLONE",
  EDIT: "EDIT",
  DRAFT: "DRAFT",
  PUBLISH: "PUBLISH",
  NOTIFY: "NOTIFY",
  ALREADY: "ALREADY",
  SCHEDULE: "schedule",
  REJECT: "REJECT",
  APPROVED: "APPROVED",
  ADD_WALLET: "ADD_WALLET",
};
exports.modules = {
  toolbar: [
    ["bold", "italic", "underline"],
    /*   [{ align: [] }][
      // toggled buttons
      ("blockquote", "code-block")
    ], */
    //   [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    //  [{ script: "sub" }, { script: "super" }], // superscript/subscript
    //  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    //  [{ direction: "rtl" }], // text direction
    //  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    //  [{ header: [1, 2, 3, 4, 5, 6, false] }],
    //  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    //  [{ font: [] }],
    //   [{ align: [] }],
    // ["clean"] // remove formatting button
    ["link"],
  ],
};
exports.IMAGE_SIZE_FOR_CAUSE = {
  HEIGHT: 630,
  WIDTH: 1200,
};
exports.IMAGE_DIMENSION = {
  HEIGHT: 603,
  WIDTH: 603,
};

exports.FINANCE_DATE_MAX_VALUE = "2100-12-31";
exports.ORGANIZATION_LOGO_SIZE = {
  HEIGHT: 100,
  WIDTH: 200,
};
exports.FILE_SIZE = 5;
exports.COPY_LINK_BASE_URL = "https://selectiva.org/emailcheckout";
exports.TOAST_MESSAGES = {
  GETTING_API_SIDE_MESSAGE: {
    ALREADY_CAUSE_NAME: "This cause name already exists, enter different name.",
    ALREADY_CAUSE_NAME_NEW:
      "This cause name has been already used. Try again with a unique name.",
  },
  ROLE: {
    CREATE: "Role created successfully.",
    UPDATE: "Role updated successfully.",
  },
  USER: {
    CREATE: "User created successfully.",
    UPDATE: "User updated successfully.",
    INACTIVE: "User inactivated successfully.",
    ACTIVE: "User activated successfully.",
  },
  ORGANIZATION: {
    CREATE: "Organization created successfully.",
    UPDATE: "Organization updated successfully.",
    INACTIVE: "Organization inactivated successfully.",
    ACTIVE: "Organization activated successfully.",
    ONBOARD_ADMIN: "Please select one.",
    FETCH_LOGO_ERROR: "Enter the website in the form.",
    NO_LOGO_FOUND: "No images found.",
    NO_LOGO_SELECTED: "Select atleast one logo.",
    VALID_WEBSITE_URL: "Enter valid website.",
    ORG_TYPE_SCHOOL_AND_PTA:
      "This NCES Id has been already used. Please try again with unique values.",
    ORG_TYPE_NPO:
      "This EIN No.has been already used. Please try again with unique values.",
  },
  FINANCE: {
    CREATE: "Finance added successfully.",
    APPROVE: "Transaction approved successfully.",
    REJECT: "Transaction rejected successfully.",
    FINANCE_BALANCE: "You don’t have sufficient amount balance to transfer.",
  },
  CAUSE: {
    CREATE: "Cause created successfully.",
    UPDATE: "Cause updated successfully.",
    FEATURE: "Cause featured successfully.",
    DELETE: "Cause deleted successfully.",
    UNPUBLISH: "Cause unpublished successfully.",
    PUBLISH: "Cause published successfully.",
    APPROVED: "Cause approved successfully.",
    ARCHIVED: "Cause archived successfully.",
    REJECT: "Cause rejected successfully.",
    DRAFT: "Cause drafted successfully.",
    IMAGE_SIZE: "The system allows a maximum file size of 5 MB.",
    VALID_CAUSE_IMAGE: "Enter a valid cause image.",
    VALIDATION_FOR_CAUSE_IMAGE:
      "Uploaded file is not a valid image. Only PNG, JPG and JPEG files are allowed.",
    NO_ORG_SELECTED: "Select an organization.",
    NO_CLUB_SELECTED: "Select club.",
    SELECT_IMAGE: "Select one feature image.",
    FEATURE_IMAGE: "Mark an image as a featured cause.",
    DELETE_FEATURE_IMAGE:
      " You can’t delete a featured image, untick the feature checkbox first.",
    ALT_TAG_IMAGE: "Max 125 characters & only alphabets allowed.",
    IMAGE_UPLOAD: "Image uploaded successfully.",
    INSUFFICIENT_PERMISSION_DELETE_CAUSE:
      "Insufficient permission to delete cause.",
    ALREADY_CAUSE_NAME:
      "This cause name is already exists, please enter different name.",

    FEATURED: "Only publish cause can be marked as a featured cause.",
    CAUSE_VERSION: {
      EMPTY_FIELD: "This field is required.",
      CANT_EDIT_PUBLISH: "You can't edit a published cause.",
      MIN_MAX: "Must be between 3-30 characters long.",
      CREATE_VERSION: "The new version is created successfully.",
    },
    IMG_DIMENSION_ERROR:
      "Sorry, your photo is too small. Please upload an image at least 604 px * 604 px large.",
  },
  PASSWORD_CHANGE: {
    CHANGE: "Password changed successfully.",
  },
  CLUB: {
    CREATE: "Club created successfully.",
    UPDATE: "Club updated successfully.",
    NO_CLUB: "No clubs found.",
  },
  DONOR: {
    UPDATE: "Donor details updated successfully.",
    RESET_PASSWORD: "Password reset link sent successfully.",
    ERROR: "There are items that require your attention.",
    ACTIVE: "Donor unblocked successfully.",
    INACTIVE: "Donor blocked successfully.",
  },
  IDLIST: {
    CREATE: "Contact Id List created successfully.",
    UPDATE: "Contact Id List updated successfully.",
    CONTACT_DELETE: "Contact deleted successfully.",
    BULK_CONTACT_DELETE: "Contacts deleted successfully.",
    LIST_DELETE: "Contact Id List deleted successfully.",
    SUPPRESSION: "Contact added to suppression list successfully.",
    BLOCK: "Contact added to block list successfully.",
    CONTACT_ADD: "Contact added to the list successfully.",
    NO_CONTACT_SELECTED: "Select atleast one contact.",
    ALREADY_ADDED: "You are already authorized.",
    TRY_AGAIN: "Please try again.",
    ALREADY_BLOCKED: "Contact/s is already blocked.",
    ALREADY_SUPPRESSED: "Contact/s is already suppressed.",
    FILE_EXPORT: "List exported successfully.",
    MODAL_MESSAGES: {
      DELETE_LIST: "Do you want to delete this list?",
      DELETE_CONTACT: "Do you want to delete this contact?",
      BULK_DELETE_CONTACT: "Do you want to delete selected contacts?",
      SUPPRRESSED_CONTACT:
        "Do you want to add the contact in suppression list?",
      BULK_SUPPRRESSED_CONTACT:
        "Do you want to add the contacts in suppression list?",
      BLOCK_CONTACT: "Do you want to add the contact in block list?",
      BULK_BLOCK_CONTACT: "Do you want to add the contacts in block list?",
      EXPORT_LIST: "Do you want to export this list?",
    },
    NOTIFY: "Your contacts are being processed. We will notify you soon.",
    NO_EMAIL_SELECTED: "Select an email from list.",
    NO_CONTACTS_FOUND: "No contacts found in the list.",
  },
  TEMPLATE: {
    CREATE: "Template created successfully.",
    UPDATE: "Template updated successfully.",
    DELETE: "Template deleted successfully.",
    DRAFT: "Template drafted successfully.",
    ARCHIVED: "Template archived successfully.",
    UNARCHIVED: "Template unarchived successfully.",
    PUBLISH: "Template published successfully.",
  },
  CAMPAIGN: {
    VALID_AMOUNT: "Enter valid amount.",
    CREATE: "Campaign sent successfully.",
    SCHEDULE: "Campaign scheduled successfully.",
    EDIT: "Campaign edit successfully.",
    DELETE: "Campaign deleted successfully.",
    CLONE: "Campaign clone successfully.",
    UNSCHEDULE: "Campaign unscheduled successfully.",
    DRAFT_CREATE: "Campaign drafted successfully.",
    PERMISSION: "Permission are not allowed.",
    ALREADY: "Campaign with this name already exists.",
    CAMPAIGN_NOT_SCHEDULE_TIME_MESSAGE:
      "Campaign can be scheduled after 30 minutes only from the current time.",
    SEND_TEST_EMAIL: {
      INVALID_NAME: "Must be between 3-30 characters long.",
      INVALID_EMAIL:
        "You have entered an invalid email address. (e.g., yourname@example.com). Please try again.",
      RESTRICT_EMAIL: "Maximum 5 email id allowed.",
    },
  },
  SPONSOR: {
    INSUFFICIENT_WALLET_BALANCE:
      "You can't sponsor a cause due to insufficient wallet balance.",
    NEW_SPONSOR_ADD: "Sponsor created successfully.",
    ALREADY_ADD_SPONSOR: "This sponsor's name already exists.",
    ALREADY_SPONSOR_EMAIL_USED:
      "This email has been already used. Please enter unique email id.",
    SPONSOR_UPDATE: "Sponsor update successfully.",
    CAUSE_SPONSORED: "Cause sponsored successfully.",
    FIELD_REQUIRED: "This field is required.",
    CHAR_LIMIT_INVALID: "Must be between 3-100 characters long.",
    CONTACT_PERSON_LIMIT_INVALID: "Must be between 3-50 characters long.",
    INACTIVE: " The sponsor successfully inactivated.",
    ACTIVE: " The sponsor successfully activated.",

    WALLET: {
      ADD_WALLET: "Balance added successfully.",
      FIELD_REQUIRED: "There are items that require your attention.",
      SPONSOR_INACTIVE_STATUS:
        "Your account has been deactivated, please activate it & try again.",
    },
  },
  INSUFFICIENT_PERMISSION: "Insufficient permission. Please contact admin.",
  EMAIL: {
    ALREADY: "Email template with this name already exists.",
  },
  SOMETHING_WENT_WRONG: "Something went wrong.",
  COMMON_FIELD: {
    EMPTY_FIELD: "This field is required.",
    NUMERIC_EMPTY: "This field is required & only numeric value allowed.",
    UNKNOWN_ERROR: "Please contact your system administrator.",
  },
};
exports.CLUB_DROPDOWN_ID_FOR_CAUSE = "2";
exports.REGEX_FOR_NUMBER = /^[0-9]+$/;
exports.REGEX_FOR_NUMBER_WITH_DASH = /^[- +()]*[0-9][- +()0-9]*$/;
exports.REGEX_FOR_NOT_ENTER_ZERO = /^[1-9][0-9]*$/;
exports.REGEX_FOR_TITLE = /^[a-zA-Z0-9!@#$&()\\-`.+,\" ]*$/gm; // ^[a-zA-Z0-9 ]{0,100}(.*[a-zA-Z0-9])?$
exports.MIN_ZOOM_FOR_SLIDER = 0.5;
exports.REGEX_FOR_DIGITAL_TIME = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
exports.REGEX_DATE_FORMAT_DD_MM_YYYY =
  /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/;
exports.REGEX_FOR_FULLNAME = /^[a-zA-Z][a-zA-Z ]*$/;
exports.REG_FOR_COUNTY = /^[a-zA-Z-\s]+$/;
exports.REG_FOR_ADDRESS = /^[a-zA-Z0-9-'#%@/,&.\s]{3,100}$/;
exports._DEFAULT_STRING = "";
exports.NOT_AVAILABLE = "NA";
exports.ZERO_AMOUNT = 0;
exports._AUTHORIZATION = "bearer " + localStorage.getItem("token");
exports.CAUSE_PERMISSION = {
  READ: "READ",
  WRITE: "WRITE",
  DELETE: "DELETE",
  FEATURE: "FEATURE",
  PUBLISH: "PUBLISH",
  APPROVE: "APPROVE",
  EDIT: "EDIT",
};
exports.FINANCE_TRANSACTION_BUTTON_TEXT = {
  APPROVE: "APPROVE",
  APPROVE_SMALL: "Approve",
  REJECT: "REJECT",
  REJECT_SMALL: "Reject",
  SELECTACK: "SELECTACK",
};
exports.REGEX_FOR_ROLE_NAME = /^[a-zA-Z ]{2,30}$/;
exports.EMAIL_REGEX =
  /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
exports.NEW_EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
exports.USER_NAME_REGEX = /^[a-zA-Z ]{2,30}$/;
exports.USER_TAB_REGEX = /^[a-zA-Z ]{3,30}$/;
exports.POOLING_REQUEST_TIME = 3000;
exports.BATCH_STATUS = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
};

exports.WEBSITE_REGEX =
  /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
// exports.WEBSITE_REGEX =
//   /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9-]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9-_#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
exports.CAUSE_DESCRIPTION_WORD_LIMIT = 1800;
exports.REGEX_FOR_ORG_NAME = /^[a-zA-Z ]{3,100}$/;
exports.WEBSITE_PROTOCOL_REGEX = /^((http|https|ftp):\/\/)/;
exports.ONLY_ALPHABETS_REGEX = /^[a-zA-Z]+$/;
exports.DROPDOWN_DISPLAY_NAME = {
  ORGANIZATION: "Organization",
  STATE: "State",
  USD: "USD",
  CLUB: "Club",
};
exports.CONTACT_LIST_FILTER = {
  ALL: "ALL",
  ACTIVE: "ACTIVE",
  BLOCKED: "BLOCKED",
  SUPPRESSED: "SUPPRESSED",
  UNSUBSCRIBED: "UNSUBSCRIBED",
  DELETE: "DELETE",
  BULK_DELETE: "BULK_DELETE",
  BULK_SUPPRESSION: "BULK_SUPPRESSION",
  BULK_BLOCK: "BULK_BLOCK",
};
exports.LIST_NAME_REGEX = /^[a-zA-Z ]{3,255}$/;
exports.CONTACT_AUTH_WINDOW_FEATURES =
  "toolbar=no, menubar=no, width=600, height=700, top=100, left=100";
exports.IDLIST_PROVIDER = {
  GMAIL: "gmail",
  YAHOO: "yahoo",
  OUTLOOK: "outlook",
};

exports.IDLIST_PERMISSON = {
  WRITE: "WRITE",
  EDIT: "EDIT",
  DELETE: "DELETE",
  READ: "READ",
  EXPORT: "EXPORT",
  ARCHIVE: "ARCHIVE",
  PUBLISH: "PUBLISH",
  IMPORTFROMFILE: "IMPORTFROMFILE",
  IMPORTFROMPROVIDER: "IMPORTFROMPROVIDER",
};

exports.GLOBAL_TEMPLATE_VARIABLES = {
  ORG_CDS_CODE: "{{org_nces_id_or_ein_no}}",
  ORG_WEBSITE: "{{org_website}}",
  ORG_COUNTY: "{{org_country}}",
  ORG_ZIP: "{{org_zip}}",
  ORG_CITY: "{{org_city}}",
  ORG_STATE: "{{org_state}}",
  ORG_STREET: "{{org_street_address}}",
  ORG_NAME: "{{org_name}}",
  ORG_PHONE: "{{org_phone}}",
  CAUSE_DESCRIPTION: "{{cause_description}}",
  CAUSE_GOAL: "{{cause_goal}}",
  CAUSE_TITLE: "{{cause_title}}",
  EMAIL: "{{email}}",
  FIRST_NAME: "{{first_name}}",
  LAST_NAME: "{{last_name}}",
  UNSUBSCRIBE_LINK: "{{unsubscribe_link}}",
};

exports.BODY_VARIABLE_REGEX = /{{(.*?)}}/g;

/* exports.TEMPLATE_FOOTER_STRING =
  '<p><br></p><div style="display: flex;justify-content: center;max-width: fit-content;margin: 0 auto;"><div class="se-component se-image-container __se__float-none" contenteditable="false"><figure style="margin: 0px 5px;"><a href="http://localhost:3000/admin/template/create#" target="" data-image-link="image"><img src="http://cdn.selectiva.org/fb.png" alt="" width="32px" data-image-link="http://localhost:3000/admin/template/create#" data-proportion="true" data-align="none" data-index="0" data-file-name="fb.png" data-file-size="0" data-origin="," data-size="," data-rotate="" data-rotatex="" data-rotatey="" data-percentage="auto,auto" style=""></a></figure></div><div class="se-component se-image-container __se__float-none" contenteditable="false"><figure style="margin: 0px 5px;"><a href="http://localhost:3000/admin/template/create#" target="" data-image-link="image"><img src="http://cdn.selectiva.org/tw.png" alt="" width="32px" data-image-link="http://localhost:3000/admin/template/create#" data-proportion="true" data-align="none" data-index="1" data-file-name="tw.png" data-file-size="0" data-origin="," data-size="," data-rotate="" data-rotatex="" data-rotatey="" data-percentage="auto,auto" style=""></a></figure></div><div class="se-component se-image-container __se__float-none" contenteditable="false"><figure style="margin: 0px 5px;"><a href="http://localhost:3000/admin/template/create#" target="" data-image-link="image"><img src="http://cdn.selectiva.org/linkedin.png" alt="" width="32px" data-image-link="http://localhost:3000/admin/template/create#" data-proportion="true" data-align="none" data-index="2" data-file-name="linkedin.png" data-file-size="0" data-origin="," data-size="," data-rotate="" data-rotatex="" data-rotatey="" data-percentage="auto,auto" style=""></a></figure></div></div><ul style="list-style: none;display: flex;justify-content: center;padding: 0;max-width: fit-content;margin: 16px auto;"><li><a href="#" style="color: #64b6d8; text-decoration: none; margin: 0 8px">Privacy Policy</a></li><li style="color: #0a090c">|</li><li><a href="#" style="color: #64b6d8; text-decoration: none; margin: 0 8px">Help</a></li><li style="color: #0a090c">|</li><li><a href="#" style="color: #64b6d8; text-decoration: none; margin: 0 8px">About Us</a></li></ul><p style="margin: 0 0 5px 0;color: #a8a8a8;text-align: center;">          © 2020, All rights reserved to          <strong>Selectiva Charities</strong></p><p style="margin: 0 0 5px 0;color: #a8a8a8;font-weight: 500;text-align: center;">          Selectiva Charities, Inc.        </p><p style="margin: 0 0 5px 0;color: #a8a8a8;text-align: center;">          2051 Junction Ave, Suite 225, San Jose CA 95131        </p><p style="margin: 0 0 5px 0;color: #a8a8a8;text-align: center;">          Selectiva Charities is IRS approved 501(c)(3) organization with EIN          84-3104779        </p><p style="margin: 16px 0 5px 0;color: #a8a8a8;text-align: center;">          Want to change how you receive these emails?        </p><p style="margin: 0 0 5px 0;color: #a8a8a8;text-align: center;">          You can          <a href="#" style="color: #c8cbcd; text-decoration: none">update your preferences</a>          or  <a href="{{unsubscribe_link}}" style="color: #c8cbcd; text-decoration: none">Unsubscribe</a>            </p>';
 */

exports.CSV_FILE_SIZE = 1;

exports.CAUSE_MEDIA_CROP_DIMENSION = { width: 1366, height: 455 };

exports.SESSION_TIMEOUT_TIME = {
  // logout: 900000,
  // reload: 900000,
  logout: 3600000, // Two hours
  reload: 3600000, // Two hours
};
